<template>
  <page>
    <div>
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field :disabled="fromBusCls" v-model="filters.busCls" :label="labels.busCls" :error-messages="errors.collect('busCls')" data-vv-name="busCls" :data-vv-as="labels.busCls" v-validate="'name|max:4'"></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field :disabled="fromTariff" v-model="filters.tarf" :label="labels.tarf" :error-messages="errors.collect('tarf')" data-vv-name="tarf" :data-vv-as="labels.tarf" v-validate="'name|max:4'"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-1"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
            <v-spacer></v-spacer>
            <div>
              <v-btn class="mr-2" color="primary" @click.native="doPrint">
                Print All Permitted Tariff
                <v-icon right>mdi-printer</v-icon>
              </v-btn>
              <v-btn color="primary" @click.native="doNew()">
                New Permitted Tariff
                <v-icon right>mdi-plus</v-icon>
              </v-btn>
            </div>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td>{{ row.item.busCls }}</td>
                <td>{{ row.item.tarf }}</td>
                <td>{{ row.item.vehRegMand ? 'Yes' : 'No' }}</td>
                <td>{{ row.item.vehValMand ? 'Yes' : 'No' }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)" query @query="doQuery(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Permitted Tariff?
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Business Class', value: 'busCls' },
        { text: 'Tariff', value: 'tarf' },
        { text: 'Is Vehicle Registration No. Mandatory?', value: 'vehRegMand' },
        { text: 'Is Vehicle Value Mandatory?', value: 'vehValMand' },
        TableConst.tableActionHeader
      ],
      labels: {
        busCls: 'Business Class',
        tarf: 'Tariff'
      },
      filters: {
        busCls: undefined,
        tarf: undefined
      },
      totalItems: 0,
      selectedProp: undefined,
      deleteProp: undefined,
      loading: false,
      promptRemove: false,
      fromBusCls: false,
      fromTariff: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  methods: {
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.getList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  busCls: datamap.busCls,
                  tarf: datamap.tarf,
                  busClsDesc: datamap.busClsDesc,
                  tarfDesc: datamap.tarfDesc,
                  vehRegMand: datamap.vehRegMand,
                  vehValMand: datamap.vehValMand
                }
                this.items.push(convertList)
              })
            } else {
              this.doNew()
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      if (this.fromBusCls) {
        this.filters.tarf = undefined
      } else if (this.fromTariff) {
        this.filters.busCls = undefined
      }
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doReview(obj) {
      this.$router.push({
        name: 'pmtTariffPerBusClsReview',
        params: {
          pmtTariffPerBusClsMode: 'review',
          fromWhere: this.fromBusCls ? 'fromBusCls' : 'fromTariff',
          pmtTariffPerBusClsObjRes: obj
        }
      })
    },
    doNew() {
      this.$router.push({
        name: 'pmtTariffPerBusClsReview',
        params: {
          pmtTariffPerBusClsMode: 'create',
          fromWhere: this.fromBusCls ? 'fromBusCls' : 'fromTariff',
          pmtTariffPerBusClsObjRes: {
            busCls: this.receivedBusCls,
            tarf: this.receivedTariff,
            busClsDesc: this.receivedBusClsDesc,
            tarfDesc: this.receivedTariffDesc
          }
        }
      })
    },
    doQuery(obj) {
      this.$router.push({
        name: 'pmtTariffPerBusClsReview',
        params: {
          pmtTariffPerBusClsMode: 'query',
          fromWhere: this.fromBusCls ? 'fromBusCls' : 'fromTariff',
          pmtTariffPerBusClsObjRes: obj
        }
      })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedProp = data
      }
    },
    async doRemove() {
      const apiURI = this.menu.deletePmtTariffPerBusCls
      if (apiURI) {
        const expand = this.selectedProp
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    async doPrint() {
      const dto = []
      dto.push({
        format: 'PDF',
        sendEmail: false
      })
      const apiURI = this.menu.printReport
      if (apiURI) {
        this.uploading = true
        try {
          await this.$http.post(apiURI, dto[0])
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.uploading = false
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.pmtTariffPerBusClsParam.menu
    },
    receivedBusCls() {
      return this.$route.params.incomingBusCls
    },
    receivedTariff() {
      return this.$route.params.incomingTariff
    },
    receivedBusClsDesc() {
      return this.$route.params.incomingBusClsDesc
    },
    receivedTariffDesc() {
      return this.$route.params.incomingTariffDesc
    }
  },
  mounted() {
    this.doInit(true)
  },
  created() {
    if (this.receivedBusCls !== 'noBusCls' && this.receivedTariff === 'noTariff') {
      this.fromBusCls = true
      this.fromTariff = false
      this.filters.busCls = this.receivedBusCls
    } else if (this.receivedBusCls === 'noBusCls' && this.receivedTariff !== 'noTariff') {
      this.fromBusCls = false
      this.fromTariff = true
      this.filters.tarf = this.receivedTariff
    } else {
      this.fromBusCls = false
      this.fromTariff = false
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
